import { styles as componentStyles } from './view.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { unsafeCSS } from 'lit';

export const styles = [unsafeCSS(`${componentStyles}`), unsafeCSS(`${colorHelpersStyles}`)];
